import { FaShoppingCart } from "react-icons/fa";
import { useCart } from "../../context/CartContext";

export default function CartCount() {
  const { cartCount } = useCart();

  return (
    <a
      href="/cart"
      className="relative flex h-10 items-center gap-2 rounded-full bg-[#e5e8e6] px-3 text-[#1e242a] shadow-sm ring-1 ring-[#1e242a]/10 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#1e242a] hover:text-white hover:shadow-md"
    >
      <FaShoppingCart className="text-[18px]" />

      <span className="hidden text-[15px] font-semibold sm:inline">
        Cart
      </span>

      {cartCount > 0 && (
        <span className="absolute -right-2 -top-2 flex h-6 min-w-[24px] items-center justify-center rounded-full bg-red-600 px-1.5 text-xs font-bold text-white ring-2 ring-white">
          {cartCount}
        </span>
      )}
    </a>
  );
}